module.exports = __webpack_public_path__ + "img/404 1@2x.a0e19426.png";